import { HomeworkActivityProgress } from '@/models/HomeworkActivity';
import { Nullable } from '@/models/Model';

export const isHomeworkPending = (
  homeworkProgress?: Nullable<HomeworkActivityProgress>,
) =>
  !!homeworkProgress &&
  homeworkProgress.answer === null &&
  homeworkProgress.activityProgress.grade === null;
